module.exports = __webpack_public_path__ + "static/deliver great employee-abfed1a34f85b31a1d83b7f580217b65.jpg";